import { inject, Pipe, PipeTransform } from '@angular/core';
import { ComponentRegistryService } from '@shared/services/component-loader';

@Pipe({
  name: 'getComponentByType',
  standalone: true,
})
export class GetComponentByTypePipe implements PipeTransform {
  private readonly componentRegistryService = inject(ComponentRegistryService);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  transform(type: string): any {
    return this.componentRegistryService.getComponentByType(type) ?? null;
  }
}
